import React from 'react';


const TimeSlotGrid = ({ selectedTime, onTimeSelect, selectedDate }) => {
  const timeSlots = [
    { time: '9:00 AM', value: '09:00', available: true },
    { time: '10:00 AM', value: '10:00', available: true },
    { time: '11:00 AM', value: '11:00', available: true },
    { time: '12:00 PM', value: '12:00', available: true },
    { time: '1:00 PM', value: '13:00', available: true },
    { time: '2:00 PM', value: '14:00', available: true },
    { time: '3:00 PM', value: '15:00', available: true },
    { time: '4:00 PM', value: '16:00', available: true },
    { time: '5:00 PM', value: '17:00', available: true },
    { time: '6:00 PM', value: '18:00', available: true },
    { time: '7:00 PM', value: '19:00', available: true }
  ];

  const formatSelectedDate = (date) => {
    if (!date) return '';
    return date?.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      {/* Header */}
      <div className="mb-6">
        <h3 className="text-lg font-heading font-semibold text-primary mb-2">
          Select Time Slot
        </h3>
        {selectedDate && (
          <p className="text-muted-foreground font-body">
            Available times for {formatSelectedDate(selectedDate)}
          </p>
        )}
      </div>
      {/* Time Slots Grid */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {timeSlots?.map((slot) => (
          <button
            key={slot?.value}
            onClick={() => slot?.available && onTimeSelect(slot)}
            disabled={!slot?.available}
            className={`
              p-4 rounded-lg border-2 text-center transition-all duration-200 font-body font-medium
              ${selectedTime?.value === slot?.value
                ? 'border-accent bg-accent text-accent-foreground shadow-soft'
                : slot?.available
                ? 'border-border hover:border-accent hover:bg-accent/10 text-foreground'
                : 'border-border bg-muted text-muted-foreground cursor-not-allowed opacity-50'
              }
            `}
          >
            <div className="text-sm">
              {slot?.time}
            </div>
            {!slot?.available && (
              <div className="text-xs mt-1 text-muted-foreground">
                Booked
              </div>
            )}
          </button>
        ))}
      </div>
      {/* Selected Time Display */}
      {selectedTime && (
        <div className="mt-6 p-4 bg-accent/10 rounded-lg border border-accent/20">
          <div className="flex items-center justify-center space-x-2">
            <div className="w-2 h-2 bg-accent rounded-full"></div>
            <span className="font-body font-medium text-accent">
              Selected: {selectedTime?.time}
            </span>
          </div>
        </div>
      )}
      {/* Note */}
      <div className="mt-4 text-center">
        <p className="text-xs text-muted-foreground font-body">
          All times are in your local timezone. Sessions typically run 15 minutes over the scheduled time.
        </p>
      </div>
    </div>
  );
};

export default TimeSlotGrid;